import { render } from "./TvmSignInNavigation.vue?vue&type=template&id=228376f0"
import script from "./TvmSignInNavigation.js?vue&type=script&lang=js&external"
export * from "./TvmSignInNavigation.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/TvmSignInNavigation/TvmSignInNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "228376f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('228376f0', __exports__)) {
    api.reload('228376f0', __exports__)
  }
  
  module.hot.accept("./TvmSignInNavigation.vue?vue&type=template&id=228376f0", () => {
    api.rerender('228376f0', render)
  })

}


export default __exports__